document.addEventListener('DOMContentLoaded', function () {
  var shareButton = document.querySelector('.share-button');
  var shareMenu = document.querySelector('.share-menu');

  if (shareButton && shareMenu) {
    shareButton.addEventListener('click', function (event) {
      event.stopPropagation();
      shareMenu.style.display = shareMenu.style.display === 'flex' ? 'none' : 'flex';
    });

    window.addEventListener('click', function () {
      if (shareMenu.style.display === 'flex') {
        shareMenu.style.display = 'none';
      }
    });

    shareMenu.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
});